import { useContext } from 'react';
import { FormControlContext } from './FormControlContext';

/**
 * A hook to retrieve form control.
 */
export const useFormControl = () => {
  const formControl = useContext(FormControlContext);

  return formControl;
};
